<template>
  <div>
    <div class="container-fluid" :style="GatImg()">
      <nav v-if="this.$session.get('MenuLog') != null && this.$session.get('MenuLog').length && this.$session.get('MenuLog').length > 0" class="navbar navbar-expand-lg navbar-dark w-100" dir="rtl">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarText">
          <ul class="navbar-nav">
            <li class="nav-item" v-for="item in this.$session.get('MenuLog')" :key="item.id">
              <a
                :title="item.routeName == 'DepositWhithoutLogin' ? ' واریز به حساب / پرداخت اقساط از طریق شماره حساب / تسهیلات یا شناسه واریز بدون ورود به سامانه' : ' درخواست افتتاح حساب به صورت غیر حضوری و توسط پرتال'"
                class="nav-link text-right"
                href="javascript:void(0)"
                @click="GotoDeposit(item)"
                style="color: #ffffff !important"
                ><i class="ml-2" :class="item.menuIcone"></i>{{ item.name }}</a
              >
            </li>
          </ul>
          <!-- <span class="navbar-text">
                    فرم واریز وجه بدون لاگین
                    </span> -->
        </div>
      </nav>

      <div v-if="Lock == true" class="row text-center">
        <div class="col-2 col-lg-3"></div>
        <div class="col-12 mt-md-0 mt-5 col-lg-6">
          <div class="card mt-5 center bg-light">
            <div class="card-body" style="padding: 10px !important; overflow: hidden">
              <div class="row">
                <div class="col-md-7 col-12 card-block bg-light text-center">
                  <div class="mt-4">
                    <!-- <b v-if="$IsNetPa() == false">سیستم یک پارچه تحت وب پاسارگاد</b> -->

                    <b>{{ $store.state.NameSandogh == null ? 'سیستم یکپارچه تحت وب پاسارگاد' : 'به سامانه خدمات الکترونیکی ' + $store.state.NameSandogh }} </b>

                    <b class="d-md-block mt-3"> خوش آمدید </b>
                  </div>
                  <article v-if="stepTwo == false && ChangePass == false">
                    <div class="input-container mt-4" v-if="!Is2Semat">
                      <i class="fa fa-user icon ml-1"></i>
                      <input class="text-center" @keypress="keypressEnter($event)" id="UserName" style="direction: ltr" type="number" v-model="UserName" placeholder=" نام کاربری " />
                      <!-- <input v-else class="text-center" @keypress="keypressEnter($event)" id="UserName" type="text" v-model="UserName" placeholder="نام کاربری" /> -->
                    </div>

                    <div class="input-container mt-4" v-if="!Is2Semat">
                      <i class="fa fa-key icon ml-1"></i>
                      <input class="text-center" id="PassWord" v-model="Pass" type="password" style="direction: ltr" placeholder="  رمز ورود" name="psw" />
                      <i class="fas fa-eye errspan" id="togglePassword" @click="TogglePassword"></i>
                    </div>

                    <!-- <div class="input-container mt-4" v-if="Is2Semat">
                      <div class="alert alert-warning">برای ادامه یکی از سمت های خود را انتخاب کنید</div>
                    </div>

                    <div class="input-container mt-4" v-if="Is2Semat && ListUserSemat != null">
                      <select class="form-control" v-model="Sematha">
                        <option value="-1">-- لطفا سمت مورد نظر را انتخاب کنید --</option>
                        <option v-for="item in ListUserSemat" :key="item.dbGrpId" :value="item">
                          {{ item.gName }}
                        </option>
                      </select>
                    </div>

                    <div class="input-container mt-4" id="DbCombo" v-if="Is2Semat && ListUserSemat != null && IdSelectedSemat != -1">
                      <select class="form-control" v-model="Db">
                        <option value="-1">-- لطفا سیستم اطلاعاتی مورد نظر را انتخاب کنید --</option>
                        his.Lock
                        <option v-for="itemDb in this.ListDB" :key="itemDb.dbGrpId" :value="itemDb.tblDBId">
                          {{ itemDb.dbName }}
                        </option>
                      </select>
                    </div> -->

                    <button :disabled="loading" id="BtnSubLogin" href="#" class="btn btn-submit mt-5 mb-1 w-50" @click="recaptcha">
                      {{ this.loadingText }}
                      <span v-show="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                    <div v-if="Is2Semat">
                      <a href="javascript:void(0);" @click.prevent="GoToDefultLogin">
                        <small class="badge badge-danger font-weight-normal">بازگشت</small>
                      </a>
                    </div>

                    <div class="mt-3">
                      <div class="d-block d-lg-none" v-if="$session.get('MenuLog') && $session.get('MenuLog').length > 0">
                        <router-link :to="{ name: $session.get('MenuLog')[0].routeName }" style="text-decoration: none; color: #7904d9">{{ $session.get('MenuLog')[0].name }}</router-link>
                      </div>
                      <div class="mt-3">
                        <router-link :to="{ name: 'Rememberpassword' }" style="text-decoration: none; color: #7904d9">رمز عبور خود را فراموش کرده ام!</router-link>
                      </div>
                      <!-- <a href="#" style="text-decoration: none; color: #7904d9;" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></a> -->
                    </div>
                  </article>
                  <article v-if="stepTwo == true">
                    <div class="row m-y-3 py-2">
                      <div class="col-3 py-1">
                        <input type="number" id="code3" @input="twoStepCode(3)" v-model="codeDigits[3]" class="form-control w-100 text-center font-weight-bold" />
                      </div>
                      <div class="col-3 py-1">
                        <input type="number" id="code2" @input="twoStepCode(2)" v-model="codeDigits[2]" class="form-control w-100 text-center font-weight-bold" />
                      </div>
                      <div class="col-3 py-1">
                        <input type="number" id="code1" @input="twoStepCode(1)" v-model="codeDigits[1]" class="form-control w-100 text-center font-weight-bold" />
                      </div>
                      <div class="col-3 py-1">
                        <input type="number" id="code0" @input="twoStepCode(0)" v-model="codeDigits[0]" class="form-control w-100 text-center font-weight-bold" />
                      </div>
                      <div class="col-12 text-center">
                        <button id="BtnSubLogin" href="#" class="btn btn-submit mt-5 mb-1 w-50" @click="recaptcha">
                          {{ this.loadingText }}
                          <span v-show="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </button>
                      </div>
                    </div>
                  </article>
                  <article class="text-center mt-2" v-if="ChangePass == true">
                    <div class="p-2 text-center alert alert-danger mt-4">
                      <span style="font-size: 14px">کاربر گرامی : لطفا برای امنیت بیشتر ، کلمه عبور خودرا تغییر دهید </span>
                      <span class="d-block mt-2"> کلمه عبور بهتر است شامل حروف بزرگ و کوچک لاتین و شامل اعداد و علامت ها باشد </span>
                      <span class="d-block">بهتر است هر چند مدت یکبار نسبت به تغییر کلمه عبور خود اقدام فرمایید </span>
                    </div>
                    <div class="row">
                      <div class="col-md-2 col-1"></div>
                      <div class="col-md-8 col-10">
                        <input class="text-center d-block w-100" type="password" style="direction: ltr" placeholder=" کلمه عبور جدید" v-model="NewPass" />
                        <input class="text-center d-block w-100 mt-4" type="password" style="direction: ltr" placeholder="تکرار کلمه عبور جدید" v-model="ConfirmNewPass" />
                        <button class="btn btn-submit mt-4 mb-1 w-75" @click.prevent="ChangePassFirstLogin">اعمال کلمه عبور جدید</button>
                      </div>
                      <div class="col-md-2 col-1"></div>
                    </div>
                  </article>
                  <div class="mt-3">
                    <a :href="UrlAboutme" target="_blank" style="text-decoration: none; color: #7904d9">درباره ما</a>
                  </div>
                  <!-- <div v-if="IsBazyabi" class="mt-3 collapse" id="collapseExample">
                                    <router-link :to="{name:'Rememberpassword'}" class="btn mt-3" style="background-color: #a8eee6; color: #6695c1;">
                                        <span class="fa fa-mobile ml-2"></span> بازیابی
                                    </router-link>

                                </div> -->
                </div>
                <!-- <div v-else class="col-md-7 col-12 card-block bg-light text-center">
                  <div class="row mt-5">
                    <div class="col-3 mt-5"></div>
                    <div class="col-6 mt-5 border-bottom pb-3">
                      <Spinner class="text-center mt-5" name="roller" color="#5274eb" />
                      <h5 class="mt-4">در حال بارگذاری اطلاعات</h5>
                    </div>
                    <div class="col-3 mt-5"></div>
                  </div>
                </div> -->
                <div id="SlidreLogin" class="col-md-5 col-12 text-left card-block rounded">
                  <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" style="width: 100%; height: 100%">
                    <ol class="carousel-indicators">
                      <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>

                      <!-- <li data-target="#carouselExampleIndicators" data-slide-to="1" ></li> -->
                    </ol>
                    <div class="carousel-inner rounded">
                      <div class="carousel-item active">
                        <a href="#" target="_blank"><img class="d-block w-100" src="/Template/NewMenu/img/Lanscape1.jpg" alt="First slide" /></a>
                      </div>

                      <!-- <div class="carousel-item ">
                                            <img class="d-block w-100" src="../../../public/Image/Ramazan2.jpg" alt="Third slide">
                                        </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="this.$session.get('CustCode') != 945" class="card-footer text-muted">
              <div class="text-center">
                طراحی و پیاده سازی توسط
                <a target="_blank" href="#">شرکت پاسارگاد</a>
                <span class="fas fa-server text-right" style="font-size: 10px !important"> Version : {{ $store.state.VersionSoftware }} </span>
              </div>
            </div>
            <div v-else class="card-footer text-muted">
              <div class="text-center">
                وب سایت رسمی نقشه پردازان آسیا نپاسازه
                <span class="fas fa-server text-right" style="font-size: 10px !important"> Version : {{ $store.state.VersionSoftware }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-12 mt-5">
          <div class="text-center font-weight-bold">
            <div class="text-light bg-danger rounded p-3" style="font-size: 40px !important">
              اتمام لایسنس نرم افزار
              <div class="text-dark mt-3" style="font-size: 25px !important">مهلت استفاده قانونی شما از این سامانه تحت وب به اتمام رسیده ، لطفا جهت تمدید با واحد فروش شرکت پاسارگاد تماس حاصل فرمایید .</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2 col-lg-3"></div>

      <a href="#" id="Nav" class="Button-Menu animate__animated animate__fadeInUpBig animate__delay-1s d-none" :class="Visibelity" @click.prevent="Menu('Nav')">طرح جدید</a>
      <a href="#" id="Riboon" class="Button-Theme animate__animated animate__fadeInUpBig d-none" :class="Visibelity" @click.prevent="Menu('Riboon')">طرح قدیم</a>
      <a href="#" class="Button-Setting d-none" @click.prevent="Visibel">منو</a>
    </div>
    <div class="container-fluid d-none" :style="GetImageMob()"></div>
    <div v-for="post in posts" :key="post.id"></div>
    <loading v-if="loadingRender"></loading>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loading from '../Tools/NetPa/Loading.vue'
export default {
  components: { Loading },
  data() {
    return {
      CustomerCode: '',
      loadingRender: false,
      enable: false,
      appsettings: {},
      NewPass: '',
      ConfirmNewPass: '',
      codeDigits: ['', '', '', ''],
      stepTwo: false,
      ChangePass: false,
      Lock: true,
      IsMobileSize: false,
      DataAxios: {
        ArryfildName: ['UserName', 'Password'],
        ArryfildValue: ['مدير', '1234'],
        Method: 'Post',
        Action: 'GetUserData',
      },
      DataAxiosWcf: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'Wcf',
      },
      DataAxiosGetGrpMenu: {
        ArryfildValue: '',
        Method: 'Get',
        Action: 'DefineDastresi/GetbvtblGrpCloudMenu',
        Token: this.$session.get('Token'),
      },
      UserGrpMenu: null,
      UserName: '',
      Pass: '',
      Omid: [],
      IsSHowMenu: 'd-none',
      ListName: ['UserName', 'Password'],
      ListValue: ['مدير', '1234'],
      Usrtoken: '',
      UserAction: 'DefineShobe ',
      UserMethod: 'Post',
      loading: false,
      loadingText: ' ورود به سامانه ',
      Is2Semat: false,
      ListUserSemat: [],
      ListGetUserData: [],
      ListDB: [],
      IdSelectedSemat: -1,
      IdSelectedDb: -1,
      valComboSemat: -1,
      howManyVerify: 0,
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: 'put',
        Action: '',
        Token: '',
        From: 'Body',
      },
      infoNetPa: null,
      CountLogin: 0,
      UrlAboutme: '',
      CodeMeli:'',
      RandomKeyLogin:''
    }
  },
  component: {},

  methods: {
    GetRouterParams(){
      if (this.$route.query.custcode == '948') {
        this.loading = true
        this.GetAppSetting().then(data=>{
          console.log(this.$route.query);
        this.CodeMeli=this.$route.query.u;
        this.RandomKeyLogin=this.$route.query.k;
        this.CustomerCode = this.$route.query.custcode
        this.LoginWithRandomKey()
        })
      }
    },
    GetAppSetting() {
      return new Promise((success, reject) => {
        var axios = require('axios')
        var config = {
          method: 'GET',
          url: '/appSettings.json?nocache=123',
          headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
            'Content-Type': 'application/json',
          },
        }
        axios(config).then((result) => {
          if (this.$store.state.VersionSoftware != result.data.VersionSoftware) {
            window.location = window.location.href + '?eraseCache=true'
          } else {
            this.appsettings = result.data
            success()
            this.gettblCustomer()
          }
        })
      })
    },
    TogglePassword() {
      if (document.getElementById('PassWord').type == 'password') {
        document.getElementById('PassWord').type = 'text'
      } else {
        document.getElementById('PassWord').type = 'password'
      }
    },
    async recaptcha() {
      if (this.appsettings.CaptchSiteKey != '') {
        await this.$recaptchaLoaded(this.LoginTo())
      } else {
        this.LoginTo()
      }
    },
    GatImg() {
      // return './Image/U1-6.png'
      return 'background-image:url("./Image/back.jpg");background-size: cover; height: 100vh;'
    },
    GetImageMob() {
      // return './Image/U1-6.png'
      return 'background-image:url("./Image/back.jpg");background-size: cover; height: 100vh;'
    },
    twoStepCode(num) {
      if (this.codeDigits[num].length >= 1 && num < 3) {
        this.codeDigits[num].slice(0, 1)
        document.getElementById('code' + (num + 1)).focus()
      } else if (num >= 3) {
        this.LoginTo()
      }
    },
    LoginTo() {
      var axios = require('axios')
      var FormData = require('form-data')
      var data = new FormData()

      if (this.UserName.trim() == '' || this.Pass.trim() == '') {
        let PassWordInput = document.getElementById('PassWord')
        PassWordInput.focus()
        this.$mySweetDefault('هشدار', 'وارد کرد نام کاربری و کلمه عبور اجباری می باشد .', 'warning', 3000)
      } else {
        if (this.UserName.length < 8) {
          this.$mySweetDefault('اطلاع رسانی', 'طول نام کاربری باید حداقل 8 رقم باشد .', 'info', 3000)
        } else {
          try {
            // خواندن تنظیمات
            // var Setting = {
            //   ArryfildValue: {},
            //   Method: 'Post',
            //   Action: 'Setting',
            // }
            // this.$PostData(Setting).then((dataSetting) => {
            //   this.CountLogin = dataSetting.countAuth
            // })
            this.CustomerCode = this.$route.query.custcode == undefined ? this.$session.get('CustCode') : this.$route.query.custcode
            this.loading = true
            this.loadingText = 'درحال بارگذاری ... '
            data.append('UserName', this.UserName)
            data.append('Pass', this.$Encryption(this.Pass))
            data.append('CustomerCode', this.CustomerCode)
            if (this.stepTwo) {
              var twoStepCode = this.codeDigits[0] + this.codeDigits[1] + this.codeDigits[2] + this.codeDigits[3]
              data.append('twoStepCode', twoStepCode)
            }
            var configNetPa = {
              method: 'post',
              url: this.appsettings.NetPaApi + 'Auth/NetPaLogin',
              headers: {},
              data: data,
            }
            axios(configNetPa)
              .then((resNetpa) => {
                if (resNetpa.data == null) {
                  this.$mySweetDefault('ورود ناموفق', 'نام کاربری و یا کلمه عبور نادرست است', 'error', 3000)
                  this.loading = false
                  this.loadingText = ' ورود به سامانه '
                } else {
                  if (resNetpa.data.status == 'success') {
                    if (resNetpa.data.data.id != null) {
                      this.infoNetPa = resNetpa.data.data
                      this.$session.start()
                      this.$session.set('TokenNetPa', this.infoNetPa.token)
                      this.$session.set('UserInfoNetPa', this.infoNetPa)
                      this.SetAxarinVorodBeSite()

                      //خواندن منوهای فعال برنامه
                      var DataAxiosMenu = {
                        ArryfildValue: '',
                        Method: 'Get',
                        Action: 'Menu',
                        Token: this.$session.get('TokenNetPa'),
                      }
                      this.$PostData(DataAxiosMenu).then((result) => {
                        this.$session.set('AllMenu', result)

                        //خواندن کل جدول منو برای بررسی دسترسی ها
                        var DataAxiosRead = {
                          ArryfildValue: {},
                          Method: 'Post',
                          Action: 'Menu/getAllmenus',
                          Token: this.$session.get('TokenNetPa'),
                        }
                        this.$PostData(DataAxiosRead).then((data) => {
                          this.$session.set('AccessMenu', data)
                          if (this.infoNetPa.countAuthFailed >= this.CountLogin || this.infoNetPa.isLockForLogin == 1) {
                            var Lock = {
                              ArryfildValue: {},
                              Method: 'Put',
                              Action: 'AxarinVorod',
                            }
                            const LockData = new FormData()

                            LockData.append('userName', this.UserName)
                            LockData.append('IsLockForLogin', 1)
                            Lock.ArryfildValue = LockData
                            this.$PostFormData(Lock)
                              .then((data) => {})
                              .finally(() => {
                                this.$mySweetDefault('ورود ناموفق', 'به دلیل ورود بیش از حد نام کاربری و کلمه عبور اشتباه، نام کاربری شما مسدود شد', 'error', 3000)
                                this.loading = false
                                this.loadingText = ' ورود به سامانه '
                              })
                          } else {
                            var DataAxiosRahbari = {
                              ArryfildValue: '',
                              Method: 'POST',
                              Action: 'Rahbari',
                              Token: this.$session.get('TokenNetPa'),
                            }
                            var DataAxiosModirShobe = {
                              ArryfildValue: '',
                              Method: 'POST',
                              Action: 'ModirShobe',
                              Token: this.$session.get('TokenNetPa'),
                            }
                            const RahbariData = new FormData()

                            RahbariData.append('wwwTblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId + '')
                            RahbariData.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId + '')
                            DataAxiosRahbari.ArryfildValue = RahbariData
                            this.$PostFormData(DataAxiosRahbari)
                              .then((res) => {
                                if (res.length > 0) {
                                  this.$session.set('IsRahbar', true)
                                } else {
                                  this.$session.set('IsRahbar', false)
                                }
                              })
                              .finally(() => {
                                const ModirShobe = new FormData()
                                ModirShobe.append('wwwTblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId + '')
                                ModirShobe.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId + '')
                                DataAxiosModirShobe.ArryfildValue = RahbariData
                                this.$PostFormData(DataAxiosModirShobe)
                                  .then((res) => {
                                    if (res.length > 0) {
                                      this.$session.set('ModirShobe', true)
                                    } else {
                                      this.$session.set('ModirShobe', false)
                                    }
                                  })
                                  .finally(() => {
                                    if (this.$session.get('UserInfoNetPa').id) {
                                      if (resNetpa.data.user && resNetpa.data.user.webPss) {
                                        this.$router.push('/PishkhanNetPa/Home')
                                      } else {
                                        if (this.$session.get('UserInfoNetPa').isHasBeenChangedPassFirstLogin) {
                                          this.ChangePass = true
                                        } else {
                                          this.$router.push('/PishkhanNetPa/Home')
                                        }
                                      }
                                    }
                                  })
                              })
                          }
                        })
                      })
                    } else {
                      this.$mySweetDefault('ورود ناموفق', 'نام کاربری و یا کلمه عبور نادرست است', 'error', 3000)
                      this.loading = false
                      this.loadingText = ' ورود به سامانه '
                    }
                  } else if (resNetpa.data.status == 'successTwoStep') {
                    this.$mySweetDefault('پیام سیستم', resNetpa.data.msg, 'info', 3000)
                    this.loading = false
                    this.stepTwo = true
                    this.$nextTick(() => {
                      this.loadingText = ' ورود به سامانه '
                      var el = document.getElementById('code0')
                      el.focus()
                    })
                  } else if (resNetpa.data.status == 'failStep') {
                    this.$mySweetDefault('پیام سیستم', resNetpa.data.msg, 'error', 3000)
                    this.loading = false
                    this.loadingText = ' ورود به سامانه '
                  } else if (resNetpa.data.status == 'fail') {
                    this.$mySweetDefault('خطا', resNetpa.data.msg, 'error', 3000)
                  }
                }
              })
              .finally(() => {})
              .catch(function (error) {
                console.log(error)
                this.loading = false
                this.loadingText = ' ورود به سامانه '
              })
          } catch (error) {
            this.loading = false
            this.loadingText = ' ورود به سامانه '
          }
        }
      }
    },
    LoginWithRandomKey() {
      var axios = require('axios')
      var FormData = require('form-data')
      var data = new FormData()

          try {
            // خواندن تنظیمات
            // var Setting = {
            //   ArryfildValue: {},
            //   Method: 'Post',
            //   Action: 'Setting',
            // }
            // this.$PostData(Setting).then((dataSetting) => {
            //   this.CountLogin = dataSetting.countAuth
            // })
            this.CustomerCode = this.$route.query.custcode == undefined ? this.$session.get('CustCode') : this.$route.query.custcode
            this.loading = true
            this.loadingText = 'درحال بارگذاری ... '
            data.append('Username', this.CodeMeli)
            data.append('LoginKey', this.RandomKeyLogin)

            var configNetPa = {
              method: 'post',
              url: this.appsettings.NetPaApi + 'Auth/NetPaLoginKey',
              headers: {},
              data: data,
            }
            axios(configNetPa)
              .then((resNetpa) => {
                if (resNetpa.data == null) {
                  this.$mySweetDefault('ورود ناموفق', 'نام کاربری و یا کلمه عبور نادرست است', 'error', 3000)
                  this.loading = false
                  this.loadingText = ' ورود به سامانه '
                } else {
                  if (resNetpa.data.status == 'success') {
                    if (resNetpa.data.data.id != null) {
                      this.infoNetPa = resNetpa.data.data
                      this.$session.start()
                      this.$session.set('TokenNetPa', this.infoNetPa.token)
                      this.$session.set('UserInfoNetPa', this.infoNetPa)
                      this.SetAxarinVorodBeSite()

                      //خواندن منوهای فعال برنامه
                      var DataAxiosMenu = {
                        ArryfildValue: '',
                        Method: 'Get',
                        Action: 'Menu',
                        Token: this.$session.get('TokenNetPa'),
                      }
                      this.$PostData(DataAxiosMenu).then((result) => {
                        this.$session.set('AllMenu', result)

                        //خواندن کل جدول منو برای بررسی دسترسی ها
                        var DataAxiosRead = {
                          ArryfildValue: {},
                          Method: 'Post',
                          Action: 'Menu/getAllmenus',
                          Token: this.$session.get('TokenNetPa'),
                        }
                        this.$PostData(DataAxiosRead).then((data) => {
                          this.$session.set('AccessMenu', data)
                          if (this.infoNetPa.countAuthFailed >= this.CountLogin || this.infoNetPa.isLockForLogin == 1) {
                            var Lock = {
                              ArryfildValue: {},
                              Method: 'Put',
                              Action: 'AxarinVorod',
                            }
                            const LockData = new FormData()

                            LockData.append('userName', this.UserName)
                            LockData.append('IsLockForLogin', 1)
                            Lock.ArryfildValue = LockData
                            this.$PostFormData(Lock)
                              .then((data) => {})
                              .finally(() => {
                                this.$mySweetDefault('ورود ناموفق', 'به دلیل ورود بیش از حد نام کاربری و کلمه عبور اشتباه، نام کاربری شما مسدود شد', 'error', 3000)
                                this.loading = false
                                this.loadingText = ' ورود به سامانه '
                              })
                          } else {
                            var DataAxiosRahbari = {
                              ArryfildValue: '',
                              Method: 'POST',
                              Action: 'Rahbari',
                              Token: this.$session.get('TokenNetPa'),
                            }
                            var DataAxiosModirShobe = {
                              ArryfildValue: '',
                              Method: 'POST',
                              Action: 'ModirShobe',
                              Token: this.$session.get('TokenNetPa'),
                            }
                            const RahbariData = new FormData()

                            RahbariData.append('wwwTblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId + '')
                            RahbariData.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId + '')
                            DataAxiosRahbari.ArryfildValue = RahbariData
                            this.$PostFormData(DataAxiosRahbari)
                              .then((res) => {
                                if (res.length > 0) {
                                  this.$session.set('IsRahbar', true)
                                } else {
                                  this.$session.set('IsRahbar', false)
                                }
                              })
                              .finally(() => {
                                const ModirShobe = new FormData()
                                ModirShobe.append('wwwTblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId + '')
                                ModirShobe.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId + '')
                                DataAxiosModirShobe.ArryfildValue = RahbariData
                                this.$PostFormData(DataAxiosModirShobe)
                                  .then((res) => {
                                    if (res.length > 0) {
                                      this.$session.set('ModirShobe', true)
                                    } else {
                                      this.$session.set('ModirShobe', false)
                                    }
                                  })
                                  .finally(() => {
                                    if (this.$session.get('UserInfoNetPa').id) {
                                      if (resNetpa.data.user && resNetpa.data.user.webPss) {
                                        this.$router.push('/PishkhanNetPa/Home')
                                      } else {
                                        if (this.$session.get('UserInfoNetPa').isHasBeenChangedPassFirstLogin) {
                                          this.ChangePass = true
                                        } else {
                                          this.$router.push('/PishkhanNetPa/Home')
                                        }
                                      }
                                    }
                                  })
                              })
                          }
                        })
                      })
                    } else {
                      this.$mySweetDefault('ورود ناموفق', 'نام کاربری و یا کلمه عبور نادرست است', 'error', 3000)
                      this.loading = false
                      this.loadingText = ' ورود به سامانه '
                    }
                  } else if (resNetpa.data.status == 'successTwoStep') {
                    this.$mySweetDefault('پیام سیستم', resNetpa.data.msg, 'info', 3000)
                    this.loading = false
                    this.stepTwo = true
                    this.$nextTick(() => {
                      this.loadingText = ' ورود به سامانه '
                      var el = document.getElementById('code0')
                      el.focus()
                    })
                  } else if (resNetpa.data.status == 'failStep') {
                    this.$mySweetDefault('پیام سیستم', resNetpa.data.msg, 'error', 3000)
                    this.loading = false
                    this.loadingText = ' ورود به سامانه '
                  } else if (resNetpa.data.status == 'fail') {
                    this.$mySweetDefault('خطا', resNetpa.data.msg, 'error', 3000)
                  }
                }
              })
              .finally(() => {})
              .catch(function (error) {
                console.log(error)
                this.loading = false
                this.loadingText = ' ورود به سامانه '
              })
          } catch (error) {
            this.loading = false
            this.loadingText = ' ورود به سامانه '
          }
        
      
    },
    GetLockData() {
      this.$store.state.loadingRender = true
      this.$PostData(this.DataAxiosWcf)
        .then((response) => {
          this.$store.state.loadingRender = false
          this.$session.set('Lock', response)
          this.$store.state.NameSandogh = response.b_CustomerName
        })
        .catch((error) => {
          this.$store.state.loadingRender = false
          console.log(error)
        })
    },
    GoToDefultLogin() {
      this.IdSelectedSemat = -1
      this.Is2Semat = false
      this.valComboSemat = -1
      this.loading = false
      this.loadingText = ' ورود به سامانه '
    },
    Visibel() {
      if (this.IsSHowMenu == 'd-none') {
        this.IsSHowMenu = ''
      } else {
        this.IsSHowMenu = 'd-none'
      }
    },
    Menu(ThemeMenu) {
      if (ThemeMenu == 'Nav') {
        this.$session.start()
        this.$session.set('MenuTheme', 'Nav')
      }
      if (ThemeMenu == 'Riboon') {
        this.$session.set('MenuTheme', 'Riboon')
      }
    },
    keypressEnter(evn) {
      if (evn.code == 'Enter') {
        //console.log(evn.target);
        if (evn.target.id == 'UserName') {
          let PassWordInput = document.getElementById('PassWord')
          PassWordInput.focus()
        }
      }
    },
    SetAxarinVorodBeSite() {
      var UserIp
      this.$GetipClient().then((data) => {
        UserIp = data.data.MyIP
        var DataAxios_AxrinVorod = {
          ArryfildValue: '',
          Method: 'POST',
          Action: 'AxarinVorod/AxarinVorod_V2/',
          Token: this.$session.get('TokenNetPa'),
        }
        const AxarinVorod = new FormData()
        AxarinVorod.append('wwwTblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        AxarinVorod.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
        AxarinVorod.append('AxarinVorodBeSite', this.$store.state.JalaliDateAndTime)
        AxarinVorod.append('IpAddress', UserIp)
        AxarinVorod.append('MacAddress', '')
        AxarinVorod.append('IsLogin', true)
        DataAxios_AxrinVorod.ArryfildValue = AxarinVorod
        this.$PostFormData(DataAxios_AxrinVorod)
      })
    },
    gettblCustomer() {
      this.loading = true
      this.loadingText = ' در حال بارگذاری اطالاعات'

      var settings = {
        method: 'Post',
        url: this.appsettings.NetPaApi + 'Setting',
        headers: {},
        data: null,
      }
      var axios = require('axios')
      axios(settings)
        .then((result) => {
          this.CountLogin = result.data.countAuth

          this.$PostData({
            ArryfildValue: {},
            Action: 'GetTblCustomer',
            method: 'GET',
            Token: '',
          })
            .then((data) => {
              let CustomerName = data.name
              if (data.custCode == 561) {
                this.$store.state.NameSandogh = 'صندوق قرض الحسنه'
                this.$session.set('NameSandogh', 'صندوق قرض الحسنه')
                CustomerName = 'صندوق قرض الحسنه'
              } else {
                this.$store.state.NameSandogh = data.name
                this.$session.set('NameSandogh', data.name)
                let word = 'تعاونی'
                if (CustomerName.indexOf(word) !== -1) {
                  this.$session.set('IsTaavoniEtebar', true)
                } else {
                  this.$session.set('IsTaavoniEtebar', false)
                }
              }
              this.$session.set('CustCode', data.custCode)
              document.title = ' خدمات الکترونیکی ' + data.name
              this.loading = false
              this.loadingText = ' ورود به سامانه'
              this.CheckupLinkPay()
            })
            .catch((e) => {
              this.gettblCustomer()
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {
          this.gettblCustomer()
        })
        .finally(() => {
          this.loading = false
        })
    },
    GotoDeposit(menuItem) {
      this.$router.push({
        name: menuItem.routeName,
      })
    },
    ReadMenu() {
      var DataAxiosMenu = {
        ArryfildValue: '',
        Method: 'post',
        Action: 'Menu/GetMenusLogin',
        Token: this.$session.get('TokenNetPa'),
      }
      this.$PostData(DataAxiosMenu)
        .then((result) => {
          this.$session.set('MenuLog', result)
          // this.updated();
        })
        .catch(() => {
          this.ReadMenu()
        })
    },
    ChangePassFirstLogin() {
      if (this.NewPass == this.ConfirmNewPass && this.NewPass.length > 4 && this.ConfirmNewPass.length > 4) {
        var DataAxiosRow = {
          ArryfildValue: '',
          Method: 'Post',
          Action: 'Auth/ChangePassFirstLogin',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('NewPass', this.NewPass)
        formData.append('CustomerCode', this.$session.get('CustCode'))
        formData.append('CodeMeli', this.$session.get('UserInfoNetPa').codeMeli)
        formData.append('OldPass', this.$session.get('UserInfoNetPa').webPss)
        formData.append('AxarinTaghirPass', this.$GetJalaliDate())

        DataAxiosRow.ArryfildValue = formData
        this.$PostFormData(DataAxiosRow).then((data) => {
          if (data.status == 'success') {
            this.$mySweetDefault('عملیات موفق', 'تغییر رمز با موفقیت انجام شد ', 'succrss', 3000)
            this.ChangePass = false
            this.loading = false
            this.loadingText = ' ورود به سامانه '
          }
        })
      } else {
        this.$mySweetDefaultTost('عملیات ناموفق', 'کلمه عبور شما باید بیشتر از 4 کارکتر باشد و باید باهم برابر باشند', 'error', 3500)
      }
    },
    CheckupLinkPay() {
      this.$GetAppsettings()
      if (this.$route.query.sh) {
        if (Number(this.$route.query.sh) > 0 && this.$route.query.sh != null) {
          this.loadingRender = true
          // this.IsQuery = true
          this.$router.push({ name: 'v', query: { sh: this.$route.query.sh } })
        } else {
          // this.IsQuery = false
        }
      } else {
        // this.IsQuery = false
      }
    },
  },
  mounted() {
    this.$GetAppsettingsAsync().then((IsMaintenance) => {
      if (IsMaintenance == true) {
        this.$router.push({ name: 'Maintenance' })
      } else {
        this.$store.state.loadingRender = false
        this.UrlAboutme = this.appsettings.UrlAboutme
        let PassWordInput = document.getElementById('UserName')
        PassWordInput.focus()

        let bootstrap = document.createElement('script')
        bootstrap.setAttribute('src', '/Template/NewMenu/js/bootstrap.bundle.js')
        document.head.appendChild(bootstrap)

        let custom = document.createElement('script')
        custom.setAttribute('src', '/Template/NewMenu/build/js/custom.js')
        document.head.appendChild(custom)
        this.gettblCustomer()
        this.ReadMenu()

        //console.log(this.$store.state.VersionSoftware);
        var ver = localStorage.getItem('VersionSoftware')

        if (ver == null) {
          localStorage.setItem('VersionSoftware', this.$store.state.VersionSoftware)

        } else {
          var OldVer = localStorage.getItem('VersionSoftware')
          var NewVer = this.$store.state.VersionSoftware
          if (OldVer != NewVer) {
            localStorage.setItem('VersionSoftware', this.$store.state.VersionSoftware)
            this.$swal({
              title: 'بروزرسانی جدید',
              text: 'نسخه جدید در دسترس میباشد ، لطفا تایید نمایید تا نسخه شما بروزرسانی شود',
              icon: 'success',
              position: 'center',
              confirmButtonText: 'تایید',
              showConfirmButton: true,
              showCancelButton: false,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload(true)
                this.GetRouterParams()
              }
            })
          }
          else{
          this.GetRouterParams()
          }
        }
      }
    })

    
  },

  computed: {
    ...mapState(['posts']),
    Visibelity() {
      return this.IsSHowMenu
    },
    Sematha: {
      get() {
        return this.valComboSemat
      },
      set(value) {
        this.valComboSemat = value
        this.ListDB = []
        for (let index = 0; index < this.ListUserSemat.length; index++) {
          const element = this.ListUserSemat[index].dbGrpId
          if (element == value.dbGrpId) {
            this.IdSelectedSemat = index
          }
        }

        // var ListSemahaDb=this.ListGetUserData[this.IdSelectedSemat]
        var ListSemahaDb = value
        var IdSematSelected = ListSemahaDb.tblGrpId

        this.ListGetUserData.forEach((element) => {
          if (element.tblGrpId == IdSematSelected) {
            this.ListDB.push(element)
          }
        })

        // for (let index = 0; index < this.ListGetUserData.length; index++) {
        //                    const element = this.ListUserSemat[index];

        //         }
      },
    },
    Db: {
      get() {
        return this.IdSelectedDb
      },
      set(value) {
        this.IdSelectedDb = value
      },
    },
  },
  created() {
    this.$session.set('ForceLoginpage', false)

    var axios = require('axios')
    var config = {
      method: 'GET',
      url: '/appSettings.json?nocache=123',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    }
    axios(config).then((result) => {
      if (this.$store.state.VersionSoftware != result.data.VersionSoftware) {
        window.location = window.location.href + '?eraseCache=true'
      } else {
        this.appsettings = result.data
        this.gettblCustomer()
      }
    })
    this.$GetAppsettings()
    // if (this.$GetJalaliDate() >= '1401/07/01' && !this.$cookies.get('IsNetPa')) {
    //   this.Lock = true
    //   this.$session.set('Lock', true)
    // } else {
    this.Lock = true
    this.$session.set('Lock', true)
    // }
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    if (vw < 420) {
      this.IsMobileSize = true
    }
    this.$session.set('MenuTheme', '')
  },
}
</script>

<style scoped>
.container-fluid a,
p,
b,
input,
.fa {
  font-size: 14px !important;
}

.navbar-dark {
  background-color: #6c519da6 !important;
}

.navbar-nav:hover {
  background-color: none !important;
}

.navbar-nav {
  background-color: none !important;
}

.center {
  -webkit-box-shadow: 5px 11px 21px 5px rgba(0, 0, 0, 0.58);
  box-shadow: 5px 11px 21px 5px rgba(0, 0, 0, 0.58);
  border: sold black;
  border-radius: 15px;
  overflow: hidden;
}

input[type='text'],
input[type='number'],
input[type='password'],
textarea,
select {
  outline: none;
}

input {
  width: 50%;
  background: transparent;
  border: none;
  border-bottom: 1px solid #a3a3a3;
}

input:focus {
  border-bottom: 2px solid #08828f;
  transition: 0.6s;
}

.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%, rgba(72, 20, 193, 1) 100%);
  /* background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%,#403c47 100%); */
}

.btn-submit:not(disabled):hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}

.Button-Setting {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  left: 40px;
  background-color: rgb(91, 71, 130);
  color: rgb(255, 255, 255);
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  line-height: 60px;
  transition: 0.3s;
}

.Button-Setting:hover {
  background-color: rgb(56, 43, 82);
  transition: 0.3s;
  color: #fff;
}

.Button-Theme {
  position: fixed;
  width: 100px;
  height: 60px;
  bottom: 40px;
  left: 110px;
  background-color: #d49220;
  color: rgb(255, 255, 255);
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  line-height: 60px;
  transition: 0.3s;
}

.Button-Theme:hover {
  background-color: #96671700;
  border: 1px solid #966717;
  transition: 0.3s;
  color: #966717;
}

.Button-Menu {
  position: fixed;
  width: 100px;
  height: 60px;
  bottom: 40px;
  left: 220px;
  background-color: #d49220;
  color: rgb(255, 255, 255);
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  line-height: 60px;
  transition: 0.3s;
}

.Button-Menu:hover {
  background-color: #96671700;
  border: 1px solid #966717;
  transition: 0.3s;
  color: #966717;
}

@media (max-width: 767.98px) {
  #SlidreLogin {
    display: none;
  }

  input {
    width: 80%;
  }

  .btn-submit {
    width: 80% !important;
  }
}

.errspan {
  /* float: right !important; */
  margin-right: -20px !important;
  cursor: pointer !important;
  /* margin-top: -20px !important; */
  position: relative !important;
  z-index: 2 !important;
  color: rgba(53, 30, 83, 0.719) !important;
}
</style>
